import { render, staticRenderFns } from "./QuestionCategorySeller.vue?vue&type=template&id=7fbf42e7&scoped=true"
import script from "./QuestionCategorySeller.vue?vue&type=script&lang=js"
export * from "./QuestionCategorySeller.vue?vue&type=script&lang=js"
import style0 from "./QuestionCategorySeller.vue?vue&type=style&index=0&id=7fbf42e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbf42e7",
  null
  
)

export default component.exports